export default __webpack_public_path__ + "static/media/13.83bc0c9d.mp3";